export default {
  Title: 'Biểu tính lương, thuế TNCN, bảo hiểm',
  MinimumSalary: 'Mức lương tối thiểu',

  ContributeEmployeePay: 'Các khoản đóng góp NLĐ đóng (%)',
  ContributeEmployeePayTooltip: 'Các khoản đóng góp người lao động đóng (%)',

  ContributeCompanyPay: 'Các khoản đóng góp CQ đóng (%)',
  ContributeCompanyPayTooltip: 'Các khoản đóng góp cơ quan đóng (%)',

  SocialInsurance: 'Bảo hiểm xã hội',
  HealthInsurance: 'Bảo hiểm y tế',
  UnEmploymentInsurace: 'Bảo hiểm thất nghiệp',
  LaborUnionFee: 'Kinh phí công đoàn',

  PersonalTax: 'Thuế thu nhập cá nhân',
  PersonalDeductionAmount: 'Giảm trừ bản thân',
  FamilyDeductionAmount: 'Giảm trừ người phụ thuộc',
};
